import { IHttpClient } from '@wix/http-client';
import {
  ITemplateRepository,
  LoadTemplatesParams,
  SearchTemplatesParams,
} from './proto/ITemplateRepository';
import {
  browseTemplates,
  searchTemplates,
} from '@wix/ambassador-funnel-templates-gallery-v2-template/http';

import { Template as AmbassadorTemplate } from '@wix/ambassador-funnel-templates-gallery-v2-template/types';
import { mapAmbassadorTemplate, Template } from '../entities/template';

export class HttpTemplateRepository implements ITemplateRepository {
  constructor(private httpClient: IHttpClient) {}

  async loadTemplates(params: LoadTemplatesParams) {
    const { categoryId, language, limit, offset } = params;

    const templatesResponse = await this.httpClient.request(
      browseTemplates({
        categoryIds: [categoryId],
        language,
        limit,
        offset,
      }),
    );

    return {
      templates: (templatesResponse.data.templates ?? []).map<Template>(
        mapAmbassadorTemplate,
      ),
      total: templatesResponse.data.page?.total ?? 0,
      offset: templatesResponse.data.page?.offset ?? 0,
    };
  }

  async searchTemplates({
    language,
    limit,
    offset,
    query,
  }: SearchTemplatesParams) {
    const templatesResponse = await this.httpClient.request(
      searchTemplates({
        language,
        limit,
        offset,
        query,
        bookType: 'studio',
      }),
    );

    const ambassadorTemplates = (
      templatesResponse.data.results?.templates ?? []
    )
      .map(({ template }) => template)
      .filter((template) => !!template) as AmbassadorTemplate[];

    return {
      templates: ambassadorTemplates.map<Template>(mapAmbassadorTemplate),
      total: templatesResponse.data.results?.page?.total ?? 0,
      offset: templatesResponse.data.results?.page?.offset ?? 0,
    };
  }
}
